export default {
    showRightSideBar(state){
        return state.showRightSideBar
    },
}